import React, { useState, useEffect } from 'react';

const FAQSection = () => {
  // State to track which FAQ is currently active/open
  const [activeIndex, setActiveIndex] = useState(null);
  
  // Log when component mounts for debugging
  useEffect(() => {
    console.log("FAQ Section mounted");
  }, []);

  // FAQ data
  const faqData = [
    {
      q: "What markets can HON-SONAR™ trade?",
      a: "HON-SONAR™ is designed to work with any market that forms technical patterns, including forex, indices, commodities, and cryptocurrencies."
    },
    {
      q: "What platform does HON-SONAR™ work with?",
      a: "HON-SONAR™ is compatible with Only MT5 platforms Currently others plateform will be added with time."
    },
    {
      q: "Do I need trading experience to use HON-SONAR™?",
      a: "While HON-SONAR™ automates pattern detection and trade execution, basic understanding of trading principles is recommended to maximize results."
    },
    {
      q: "How does HON-SONAR™ manage risk?",
      a: "The system employs multiple risk management features including dynamic position sizing, adaptive stop-loss placement, partial profit taking, and maximum drawdown protection."
    },
    {
      q: "Is there customer support available?",
      a: "Yes, all HON-SONAR™ users receive dedicated support and regular updates as market conditions evolve."
    },
    {
      q: "Does HON-SONAR™ require constant monitoring?",
      a: "No. While you can monitor its performance, HON-SONAR™ is designed to operate autonomously, sending alerts via Telegram when significant events occur."
    }
  ];

  // Enhanced click handler with debugging
  const handleFaqClick = (index, e) => {
    // Stop event propagation to prevent interference from parent components
    if (e) {
      e.stopPropagation();
      e.preventDefault();
      console.log("FAQ clicked:", index);
    }
    
    // Toggle the active state
    setActiveIndex(prevIndex => {
      const newIndex = prevIndex === index ? null : index;
      console.log("Setting active FAQ from", prevIndex, "to", newIndex);
      return newIndex;
    });
  };

  return (
    <section id="faq" className="py-20 bg-gray-50 w-full">
      <div className="w-full px-4">
        {/* Centered heading and paragraph at the top */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">Frequently Asked Questions</h2>
          <p className="text-xl text-gray-600 mx-auto">
            Everything you need to know about HON-SONAR™
          </p>
        </div>

        {/* FAQ accordion directly below */}
        <div className="max-w-3xl mx-auto">
          {faqData.map((faq, index) => (
            <div key={index} className="mb-4">
              {/* Using button element for better accessibility and click handling */}
              <button 
                type="button"
                className={`w-full text-left p-5 bg-white rounded-lg shadow-md border ${activeIndex === index ? 'border-indigo-300 shadow-indigo-100' : 'border-gray-200'}`}
                onClick={(e) => handleFaqClick(index, e)}
                style={{cursor: 'pointer'}}
                aria-expanded={activeIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <div className="flex justify-between items-center">
                  <h3 className={`font-bold text-lg ${activeIndex === index ? 'text-indigo-600' : 'text-gray-800'}`}>
                    {faq.q}
                  </h3>
                  <div className={`h-8 w-8 rounded-full flex items-center justify-center ${activeIndex === index ? 'bg-indigo-100 rotate-180' : 'bg-gray-100'}`}>
                    <svg 
                      className={`h-4 w-4 ${activeIndex === index ? 'text-indigo-600' : 'text-gray-500'}`} 
                      xmlns="http://www.w3.org/2000/svg" 
                      viewBox="0 0 20 20" 
                      fill="currentColor"
                    >
                      <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>
                
                {/* Render answer separately from button click area for better accessibility */}
              </button>
              
              {/* Separate answer div that shows/hides based on state */}
              {activeIndex === index && (
                <div 
                  id={`faq-answer-${index}`}
                  className="mt-2 p-5 pt-4 text-gray-600 border border-t-0 border-gray-200 rounded-b-lg bg-white"
                >
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;